<template>
    <v-navigation-drawer app permanent expand-on-hover :rail="rail" @mouseenter="hovering = true"
        @mouseleave="hovering = false">
        <v-list dense>
            <v-list-item v-for="item in menuItems" :key="item.title" :to="!item.external ? item.route : undefined"
                :exact="true" @click="handleClick(item)" class="menu-item"
                :class="{ 'menu-active menu-active-tonal': $route.path === item.route }" v-tooltip:end="item.tooltip">
                <template v-slot:prepend>
                    <v-icon>{{ item.icon }}</v-icon>
                </template>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <div class="pa-2">
                <v-btn block class="opacity-70" color="secondary" variant="tonal" prepend-icon="mdi mdi-logout-variant"
                    v-tooltip:end="'Cerrar Sesión'" @click="logout">
                    {{ !rail || hovering ? 'Cerrar Sesión' : '' }}
                </v-btn>
            </div>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { menus, menuAccessLevel } from '@/menu';
import eventBus from '@/config/eventBus';
import { parseJwt } from '@/api/auth';

export default {
    name: 'NavBar',
    data() {
        return {
            hovering: false,
            menuItems: null,
            authorityLevel: 1,
			username:null,
        };
    },
    created() {
        const accessToken = sessionStorage.getItem("access_token");
        const tokenData = parseJwt(accessToken);
        const tokenAuthorityLevel = tokenData?.authority_level != null
            ? String(tokenData.authority_level)
            : null;

        if (tokenAuthorityLevel && Object.hasOwnProperty.call(menuAccessLevel, tokenAuthorityLevel)) {
            this.authorityLevel = tokenAuthorityLevel;
        }

        
        this.menuItems = menus.filter(menu => menuAccessLevel[this.authorityLevel].includes(menu.id));

    },
    beforeUnmount() {
        eventBus.off('navbar-data');
    },
    props: {
        rail: {
            type: Boolean,
            required: true,
        }
    },
    methods: {
        async logout() {
            this.$emit('logout');
        },
        handleClick(item) {
            if (item.external) {
                window.open(item.route, '_blank');
            } else {
                this.$router.push(item.route); // Redirige internamente usando vue-router
            }
        },
    }
};
</script>

<style scoped>
.menu-item.v-list-item--active,
.menu-item.menu-active {
    background-color: var(--twitter-color);
    color: #ffffff;
}

.menu-item.menu-active-tonal {
    background-color: transparent;
    color: var(--twitter-color);
    opacity: .9;
}

.menu-item.menu-item:hover {
    color: var(--twitter-color);
}

.menu-item:hover {
    color: var(--twitter-color);
}
</style>
